jQuery( document ).ready( function( $ ) {
	
    var $body = $('body');
  	var $bundle = $('.bundle');
  	var $swatch = $('.swatch');
	var $swatchGalleries = $('.gallery-set');  
    var $buttonAddToBasket = $('.button-add-to-cart');
    var $variationSelect = $('.product-variation-select');
  	var $price = $('.product-title-price');  
  	var queue = [];
  	var isBundle = false;
  
  	if ($('.product-form-bundle').length > 0) {
  		isBundle = true;
    } 
  	
    // Add to Basket
    if (isBundle) {
      $buttonAddToBasket.on('click', function(e) {

          e.preventDefault();

          // Build our array of products
          productBuildCartQueue();

          // Start adding products to the cart
          productProcessQueue();          

      });
    }
                                                         
        // On variation change update pricing and quantity limits      
      	$variationSelect.on('change', function(e) {

     	  var variationID = $(this).val();
		  var variation = productFindVariationByID(variationID);   
          
          // Update quantity
          productUpdateQuantity($(this), variation);

          // Update prices
       	  productUpdatePrice(); 
          
          // Update Gallery
          productUpdateGallery(variation);
        	
        });

      	// On swatch change
      	if ($swatch.length > 0 ) {
      
          var $swatchesLabel = $('.product-swatches label span');
		  var $swatchesSelect = $('.product-swatches select');
          
          // Update swatch on click
          $swatch.on('click', function(e) {
              if (!$(this).hasClass('active')) {
                  $swatch.removeClass('active');	
                  $(this).addClass('active');
                  $swatchesLabel.text($(this).data('label')).data('value', $(this).data('label'));
              
              	  // Reset Variations
                  if (isBundle) {
                  	productResetVariations();
                  }
          	  	  // Update gallery set
                  key = replaceAll($(this).data('value').toLowerCase(), ' ', '');
             	  $swatchGalleries.removeClass('active').filter('.' + key ).addClass('active');          
                  
                
              	  // Show bundles on click
              	  if (isBundle) {
             	
                		$bundle.removeClass('active');
                		$('.bundle.' + $(this).data('value').toLowerCase().replace(' ', '')).addClass('active');
                  } else {
                        $bundle.removeClass('active');
                    	$('.product-container.' + $(this).data('value').toLowerCase().replace(' ', '')).addClass('active');
                  }

                  // Update Price range
                  $price.html($('.bundle.active .bundle-pricing-range').html());
                
                  // Remove helper class
                  $body.removeClass('no-swatch-selected');
                	
                  // Update slick slider on mobile
                  productGalleryUpdate();
                
                  // Scroll top
                  $(window).scrollTop(0);
              } 
          });

          // Update label on hover
          $swatch.hover(function(e) {
              $swatchesLabel.text($(this).data('label'));
          }, function() {
              $swatchesLabel.text($swatchesLabel.data('value'));              
          });
                    
        }
      
      	// Image Zoom  
      	$('.zoom-button').each(function(e) {
          	
          	$(this).on('click', function(e) {
          		e.preventDefault();
              	              
              	if ($(this).hasClass('active')) {
              	
                	$(this).removeClass('active');
	
                  	$(this).prev().removeClass('active');
                  	
                  	$(this).prev().trigger('zoom.destroy');

                } else {
                  
                  	$(this).addClass('active');
                  	$(this).prev().addClass('active');

                    $(this).prev().zoom({
                      url: $(this).prev().data('href'),
                      magnify : 0.75,
                      on : 'mouseover'
                    });
                  
                }
            });
      	});  
   
      	// Update prices on quantity change
      	$('.quantity-container input').on('change', function(e) {
        	// Update prices
       	  	productUpdatePrice();         		
        });
      
        // Update bundles and swatch on deeplink
        if (window.location.hash) {
            var colour = window.location.hash.substr(1);

            // Update swatch
            $swatch.removeClass('active');	
            $('.swatch.' + colour).addClass('active');
            $swatchesLabel.text($('.swatch.' + colour).data('label')).data('value', $('.swatch.' + colour).data('label'));

            // Show bundle set
          	if (isBundle) {
            	$bundle.removeClass('active');
            	$('.bundle.' + colour.replace(' ', '')).addClass('active');
            }
          
          	// Show Gallery set
            $swatchGalleries.removeClass('active').filter('.' + colour).addClass('active');          
			productGalleryUpdate();
          
          	// Remove helper class
          	$body.removeClass('no-swatch-selected');
        }
      
 
  	
  	function productBuildCartQueue() {
      	
		var $products = $('.product-container.active .product-variation-select');   
      	queue = [];
      
      	$products.each(function(e) {

            id = $(this).val();
            quantity = $(this).next().children('input').val();
			          
            if (quantity > 0 ) {
              queue.push( {
                  variantId: id,
                  quantity: quantity
              });
            }
        
      	});      
    }

  	function productProcessQueue() {
      	// If we still have requests in the queue, let's process the next one.
        if (queue.length) {
            var request = queue.shift();
			// Add to basket
          	CartJS.addItem(request.variantId, request.quantity);
          
          	// Move onto the next item
          	productProcessQueue();
          
        } else {
           // Finished, show the mini cart
           modalCart.show();
        }
    }
  
  	function productUpdateQuantity($select, variation) {
		
		var $quantity = $select.next().children('input');
      	      	
      	// Update quantity input limits
      	if (variation['inventory_policy'] != 'continue') {
			// Set max quantity
		 	$quantity.attr('max', variation['inventory_quantity'] );
        } else {
			// Sell through, remove max
			$quantity.removeAttr('max');        
        }
      
    }

  	function productUpdatePrice() {
    
    	totalPrice = 0;
        totalCompareAtPrice = 0; // Compare at price
      	
      	var $products = $('.product-container.active .product-variation-select');
      
      	$products.each(function(e) {
       	
        	quantity = $(this).next().children('input').val();
          	
          	if ( quantity > 0 && $(this).val() ) {
            	var variation = productFindVariationByID($(this).val());
              
              	if (variation) {
              		totalPrice = totalPrice + ( variation['price'] * quantity );

                    // On Sale
                    if ( variation['price'] != variation['compare_at_price'] ) {
                      totalCompareAtPrice = totalCompareAtPrice + ( variation['compare_at_price'] * quantity );
                    }
                }
              
            }
          
        });
 
      	if (totalPrice > 0 ){ 
        	// Add decimals back into the price, as shopify doesn't provide EUR price 
        	// In a sane fashion
        	totalPrice = totalPrice/100;
            totalCompareAtPrice = totalCompareAtPrice/100;
          
            if ( totalCompareAtPrice > 0 ) {
              // On Sale
              output = '<ins>' + currency + totalPrice.toFixed(2) + '</ins> <del>' + currency + totalCompareAtPrice.toFixed(2)  + '</del>';
            } else {
              // Normal price
              output = currency + totalPrice.toFixed(2);
            }
          
      		$price.html(output);
        	$buttonAddToBasket.removeAttr('disabled');
      	} else {
          	// Nothing selected, disable add to basket
        	$price.html($price.data('default'));
        	$buttonAddToBasket.attr('disabled','disabled');
      	}    
            
    }  
  
  	function productUpdateGallery(variation) {
      	      
  		// Move gallery to variation image
     	if (variation['image']) {
          var imageSrc = variation['image'];
          var image = $('.gallery-set.active .slide[data-variant-image*="' + imageSrc + '"]')
         

          if (image.length) {
            
              $(window).scrollTop(image.offset().top);
              
             
            
              if ($(window).width() <= 768 ) {
                
             	index = $('.gallery-set.active .slide').index(image);
              	$('.gallery-set.active').slick('slickGoTo', index, true);
              }
          }	
        }
    }
  
  	function productResetVariations(){

      var $products = $('.bundle .product-variation-select');   
            
      $products.each(function() {
        
        // Reset Variation
      	$(this).children('option:not([value])').prop('selected', true);
        
        // Reset Quantities
        $(this).next().children('input').val(1);
        
      });
      
      // Reset add to basket / price
      $price.html($price.data('default'));
      $buttonAddToBasket.attr('disabled','disabled');      
            
   	}
  
  	function productFindVariationByID(id) {
      	for (var i = 0; i < variations.length; i++) {
          	if (variations[i]['id'] == id) {
        	    return(variations[i]);
        	}
    	}
    	return '';
    }

   	function productGalleryUpdate() {  
      	if ($(window).width() <= 768 ) {
              	$('.gallery-set.active').slick('unslick').slick({		  
                      infinite	: false,	
                      dots		: true,	
                      arrows	: false,
                      slidesToShow: 1,
            	}); 
        }
    } 
	function replaceAll(str, find, replace) {
  		return str.replace(new RegExp(find, 'g'), replace);
	}  
});